import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ServicioImprimirAdmisionService,
  ParametrosImprimirAdmisionEntity,
  EmpresaAdmision,
  InformacionAfiliadoEntity,
  EntidadEmpresarial,
  InformacionUsuarioEntity
} from 'src/app/services/servicio-imprimir-admision.service';
import { ServicioMedicamentosHomologadosService, ObjectRequest } from 'src/app/services/servicio-medicamentos-homologados.service';

@Component({
  selector: 'app-reporte-medicamentos-homologados',
  templateUrl: './reporte-medicamentos-homologados.component.html',
  styleUrls: ['./reporte-medicamentos-homologados.component.css']
})
export class ReporteMedicamentosHomologadosComponent implements OnInit {
  private parametrosUrl: ParametrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: '',
    uncoAdmision: ''
  };

  public errorDataReporte = false;
  public loading = true;
  public error = false;
  public uncoEmpresa: string;
  public opcion: string;
  public dataKeys: any[] = [];
  public dataReporte: any;
  public fechaImpresion = new Date();
  public empresa: string;
  public listaEmpresas: EmpresaAdmision[] = [];
  public dataAfiliado: InformacionAfiliadoEntity = {
    consecutivoAdmision: '',
    descripcionEmpresa: '',
    descripcionEstadoAdmision: '',
    descripcionEstratoAfiliado: '',
    descripcionSede: '',
    descripcionTipoAfiliado: '',
    direccionAfiliado: '',
    edad: '',
    fechaAdmision: '',
    fechaNacimiento: '',
    nombreAfiliado: '',
    numeroIdentificacionAfiliado: '',
    telefonoAfiliado: '',
    uncoSede: 0,
    valorTotalAtencion: '',
    ValorTotalIva: '',
    ValorTotalServicios: '',
    ValorTotalSuministros: ''
  };
  public dataEntidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: ''
  };
  public dataUsuario: InformacionUsuarioEntity = {
    nombreUsuario: '',
    codigoBarrasImprime: ''
  };

  constructor(
    private servicioAdmision: ServicioImprimirAdmisionService,
    private servicioMedicamentos: ServicioMedicamentosHomologadosService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.parametrosUrl.codigoBaseDatos = params.codigoBaseDatos;
      this.parametrosUrl.uncoSede = params.uncoSede;
      this.parametrosUrl.uncoLogin = params.uncoLogin;
      this.parametrosUrl.uncoAdmision = params.uncoAdmision;
    });
  }

  ngOnInit() {
    this.getFilterEmpresas();
    this.getInfoEntidadEmpresarial();
    this.getInfoUsuario();
  }

  public getTipoReporte (opcion: string) {
    this.opcion = opcion;
  }

  public getGenerar() {
    this.getEmpresa(this.uncoEmpresa);
  }

  public getEmpresa(uncoEmpresa: string) {
    if (uncoEmpresa !== undefined) {
      this.listaEmpresas.forEach(empresa => {
        if (empresa.uncoEmpresa.toString() === uncoEmpresa) {
          this.uncoEmpresa = uncoEmpresa;
          this.empresa = empresa.descripcionEmpresa;

          if (this.opcion !== undefined) {
            this.getInfoAfiliado(uncoEmpresa);
          }
        }
      });
    }
  }

  public getPrint() {
    window.print();
  }

  /* Consumo de los servicios */

  private async getFilterEmpresas() {
    const response = await this.servicioAdmision.getEmpresasAdmision(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if ( data !== null && data !== [] ) {
        this.listaEmpresas = data;
      }
      // console.log(data);
    }, error => {
      this.error = true;
      console.log(error);
    });
  }

  private async getInfoAfiliado( uncoEmpresa: string ) {
    const response = await this.servicioAdmision.getInfoAfiliado(this.parametrosUrl, uncoEmpresa);

    response.subscribe( (data: any) => {
      if ( data !== null ) {
        this.dataAfiliado = data[0];
        this.getDataMedicamentosHomologados(uncoEmpresa);
      }
      // console.log(this.dataAfiliado);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getInfoUsuario() {
    const response = await this.servicioAdmision.getInformacionUsuario(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataUsuario = data[0];
      }
      // console.log(this.dataUsuario);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getInfoEntidadEmpresarial() {
    const response = await this.servicioAdmision.getEntidadEmpresarial(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataEntidadEmpresarial = data[0];
      }
      // console.log(this.dataEntidadEmpresarial);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getDataMedicamentosHomologados( uncoEmpresa: string ) {

    const params: ObjectRequest = {
      codigoBaseDatos: this.parametrosUrl.codigoBaseDatos,
      uncoAdmision: this.parametrosUrl.uncoAdmision,
      uncoOpcion: '0',
      uncoEmpresa: uncoEmpresa
    };

    if ( this.opcion !== undefined ) {
      const response = await this.servicioMedicamentos.getDataReporte(params, this.opcion);

      response.subscribe( (data: any) => {
        if (data != null) {
          this.dataKeys = Object.keys(data);
          this.dataReporte = data;
          this.loading = false;
          // console.log(Object.keys(data));
          // console.log(data);
        }
      }, error => {
        this.errorDataReporte = true;
        this.loading = false;
        console.log(error);
      });
    }
  }
}
